<template>
  <span v-if="showIdentifier">{{ showIdentifier }}</span>
</template>
<script>
import { defineComponent, computed } from "vue";
import gql from "fraql";

/*#__PURE__*/
export default defineComponent({
  name: "AppShowPersonIdentifier",
  props: {
    person: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  setup(props) {
    const showIdentifier = computed(
      () => props.person.identifier || props.person.identifierMasked
    );

    return {
      showIdentifier
    };
  },
  fragments: {
    person: gql`
      fragment _ on Person {
        id
        identifier
        identifierMasked
      }
    `
  }
});
</script>
